import { Flex, IconButton, Text } from '@wyz/ui';
import { useModalState } from '@wyz/utils';
import { isEmpty } from 'lodash-es';
import * as React from 'react';
import { Trans } from '~/common/context';
import { ROLES } from '~/common/helpers';
import { useAccessControl } from '~/common/hooks';
import { QuoteRecipientModal } from '~/purchase/components';
import { IQuote } from '~/purchase/types';

interface QuoteRecipientFieldProps {
  quote: IQuote;
  value: string;
  /** Tells apart the two instances rendered on a same row (`client` / `registration`). */
  idPrefix: string;
  /** Extra recipient info rendered inside the same block (e.g. the email line). */
  children?: React.ReactNode;
}

export const QuoteRecipientField = ({
  quote,
  value,
  idPrefix,
  children,
}: QuoteRecipientFieldProps) => {
  const acl = useAccessControl();
  const [recipientModal, recipientModalHandlers] =
    useModalState<'EDIT_RECIPIENT'>();

  const canEdit = acl.isGranted([ROLES.ROLE_QUOTE_UPDATE]);
  const displayedValue = value.trim();

  const open = () => recipientModalHandlers.open('EDIT_RECIPIENT');

  return (
    <>
      {/* Only the pencil opens the modal — the recipient text itself stays inert. */}
      <div>
        <Flex alignItems='center' justifyContent='start' className='space-x-1'>
          <Text
            weight='semi-bold'
            heading='xs'
            className='text-wrap text-break'
          >
            {isEmpty(displayedValue) ? (
              <Trans i18nKey='app.purchase.quote.history.table.recipient.to_fill' />
            ) : (
              displayedValue
            )}
          </Text>
          {canEdit && (
            <IconButton
              id={`edit-recipient-${idPrefix}-${quote.reference}`}
              icon='edit'
              iconSize='xs'
              size='xs'
              variant='link'
              onClick={open}
            />
          )}
        </Flex>
        {children}
      </div>
      {recipientModal === 'EDIT_RECIPIENT' && (
        <QuoteRecipientModal
          quote={quote}
          onClose={recipientModalHandlers.close}
        />
      )}
    </>
  );
};
